import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isLocal } from '../../helpers/environment';
import * as Sentry from '@sentry/react';
import { frontendError } from '../../actions/application';
import Error from '../../Pages/Error';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  frontendError: () => void;
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {
  state = {
    hasError: null,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (isLocal()) {
      console.error(error, errorInfo);
    }
    this.setState({ hasError: true }, () => {
      Sentry.captureReactException(error, errorInfo);
      this.props.frontendError();
    });
  }

  render() {
    if (this.state.hasError) {
      return <Error />;
    } else {
      return this.props.children;
    }
  }
}

const mapDispatchToProps = {
  frontendError,
};

export default connect(null, mapDispatchToProps)(ErrorBoundary);
